module.exports = __webpack_public_path__ + "static/media/dawn-icon.54e34c5d.png";